import { LegacyTablerIconSize } from '#pplx/frontend/aether/primitives/IconPrimitive/iconSizing.js';
const ICON_SIZE_NUMERIC_MAP = {
    tiny: LegacyTablerIconSize.xs,
    small: LegacyTablerIconSize.sm,
    medium: LegacyTablerIconSize.md,
    default: LegacyTablerIconSize.base,
    large: LegacyTablerIconSize.lg,
    xlarge: LegacyTablerIconSize['2xl'],
};
const ICON_STROKE_WIDTH_NUMERIC_MAP = {
    xlarge: 1.8,
};
export const getIconSizePx = (size) => ICON_SIZE_NUMERIC_MAP[size];
export const getIconStrokeWidthPx = (size) => ICON_STROKE_WIDTH_NUMERIC_MAP[size];
//# sourceMappingURL=getIconSizePx.js.map